export default __webpack_public_path__ + "static/media/Logo-DTec-(1)-Branco 1.04f4b08b.svg";